/* eslint jsx-a11y/label-has-associated-control: 0 react/default-props-match-prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';

import { interestedInOptions, categoryOptions, subcategoryOptions } from './constants';

export const FormSelect = ({
  name,
  list,
  multitple = false,
  title,
  required = true,
  register,
}) => (
  <select {...register(name)} multiple={multitple} title={title} required={required}>
    {list.map((option) => (
      <option key={`${option}`} value={option}>
        {option}
      </option>
    ))}
  </select>
);

const MainForm = ({ register, errors }) => (
  <>
    Interested in:
    {' '}
    <small style={{ fontSize: '10px' }}>(Control or cmd click for multiple answers)</small>
    *
    <FormSelect
      list={interestedInOptions}
      multitple
      title="Interested in"
      name="00N1Q00000TGIOl"
      register={register}
    />
    {errors['00N1Q00000TGIOl'] && 'This field is required'}
    <br />
    <h3>Give Us Your Pitch!</h3>
    <label htmlFor="company">Company*</label>
    <input type="text" {...register('company', { maxLength: 40, required: true })} />
    {errors.company && 'This field is required'}
    <br />
    Company Bio:
    {' '}
    <small style={{ fontSize: '10px' }}>(max 255 characters)*</small>
    <textarea
      name="00N1Q00000TGGY0"
      type="text"
      wrap="soft"
      {...register('00N1Q00000TGGY0', { maxLength: 255, required: true })}
    />
    {errors['00N1Q00000TGGY0'] && 'This field is required'}
    <br />
    Category*:
    <FormSelect
      list={categoryOptions}
      multitple={false}
      title="Category"
      name="00N1Q00000Sv0zd"
      register={register}
    />
    <br />
    Subcategory*:
    <FormSelect
      list={subcategoryOptions}
      multitple={false}
      title="Subcategory"
      name="00N1Q00000Sv0zi"
      register={register}
    />
    <br />
    Product Name(s)*:
    <textarea
      name="00N1Q00000TGGYF"
      type="text"
      wrap="soft"
      {...register('00N1Q00000TGGYF', { required: true })}
    />
    {errors['00N1Q00000TGGYF'] && 'This field is required'}
    <br />
    MSRP*:
    <input
      name="00N1Q00000TGIOg"
      type="text"
      {...register('00N1Q00000TGIOg', { required: true })}
    />
    {errors['00N1Q00000TGIOg'] && 'This field is required'}
    <br />
  </>
);

MainForm.defaultProps = {
  register: () => null,
  errors: {},
};

MainForm.propTypes = {
  register: PropTypes.func,
};

export default MainForm;
